import './styles.css';

export default function Progress({ 
  currentStep,
  totalSteps,
  selectedBusinessType,
  isVisible
}) {
  let displayStep = currentStep > 1 
    ? (selectedBusinessType === 'corporate' && currentStep === 5 ? 3 : currentStep - 1)
    : 0;

  if(displayStep > totalSteps - 1) {
    displayStep = totalSteps - 1;
  }

  return (
    <div className={`onboarding-progress-container ${isVisible ? ' visible' : ''}`}>
      <div className="onboarding-progress-info">
        <span>Progress</span>
        <span>{displayStep} of {totalSteps - 1}</span>
      </div>
      
      <div className="onboarding-progress-bar">
        <div
          className="onboarding-progress-bar-fill" 
          style={{ width: `${currentStep === 1 ? 0 : ((currentStep - 1) / (totalSteps - 1) * 100)}%` }} 
        />
      </div>
    </div>
  )
};